import { combineReducers } from 'redux';

import types from 'frontend/state/actionTypes';
import { toggleReducer } from 'frontend/state/utils';

export default combineReducers({
  useProfilesets: toggleReducer({
    toggle: types.TOGGLE_USE_PROFILESETS,
    initial: false,
  }),
});

export const selectors = {
  useProfilesets: state => state.simbot.optimize.download.useProfilesets,
};
